import mitt from 'mitt';

const emitter = mitt();

export const ShareService = {
    open(data) {
        emitter.emit('open', data);
    },
    close() {
        emitter.emit('close');
    },
    on(event, handler) {
        emitter.on(event, handler);
    },
    off(event, handler) {
        emitter.off(event, handler);
    }
};
